var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.savvyEnabledLoggedOutHomepage
    ? _c(
        "Landing",
        { staticClass: "homepage" },
        [
          _c("Banner"),
          _vm._v(" "),
          _c("LandingHeaderV2", {
            attrs: {
              "ax-params": {
                ids: {
                  headerLogInBtn: "clicked_login_from_header",
                  stickyHeaderSignUpBtn: "clicked_start_free_trial_from_home",
                  stickyHeaderLogInBtn: "clicked_login_from_home"
                }
              }
            }
          }),
          _vm._v(" "),
          _c("LandingHeroV2", {
            staticClass: "logged-out",
            attrs: {
              "video-url": _vm.videoUrl,
              "cta-ax-params": {
                axId: "clicked_start_free_trial_from_home_hero",
                axType: "button"
              },
              "cta-button-text": "Get started",
              isExperiment: _vm.isExperiment
            },
            scopedSlots: _vm._u(
              [
                _vm.isExperiment
                  ? {
                      key: "header",
                      fn: function() {
                        return [
                          _vm._v("\n      The best way to learn\n      "),
                          _c("EmphasisText", [
                            _vm._v("math and computer science")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  : {
                      key: "header",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n      Join 10+ million people excelling in\n      "
                          ),
                          _c("EmphasisText", [_vm._v("math and science")])
                        ]
                      },
                      proxy: true
                    },
                _vm.isExperiment
                  ? {
                      key: "intro-text",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n      Guided interactive problem solving that's effective and fun. Master concepts in 15 minutes a\n      day.\n    "
                          )
                        ]
                      },
                      proxy: true
                    }
                  : {
                      key: "intro-text",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n      For lifelong learners of any age, Brilliant replaces lecture videos with hands-on,\n      interactive problem solving. It’s a better (and more fun) way to learn.\n    "
                          )
                        ]
                      },
                      proxy: true
                    }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", {
              staticClass: "divider",
              class: { "is-experiment": _vm.isExperiment }
            })
          ]),
          _vm._v(" "),
          _c("Summary"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "divider" })
          ]),
          _vm._v(" "),
          _c("LearningPaths", { attrs: { "ax-id-prefix": "homepage" } }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "divider" })
          ]),
          _vm._v(" "),
          _c("PrinciplesOfLearning"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "divider" })
          ]),
          _vm._v(" "),
          _c("JoinCTA", {
            attrs: { "btn-ax-id": "clicked_start_free_trial_from_home_footer" }
          }),
          _vm._v(" "),
          _c("LandingFooter"),
          _vm._v(" "),
          _vm.show_sponsor_modal ? _c("SponsorModal") : _vm._e(),
          _vm._v(" "),
          _c("JoinClassroomModal"),
          _vm._v(" "),
          _vm.isPbsNovaTraffic ? _c("NovaSponsorModal") : _vm._e(),
          _vm._v(" "),
          !_vm.privacyProperties.viewed_privacy_banner
            ? _c("PrivacyBanner")
            : _vm._e(),
          _vm._v(" "),
          _vm.show_just_deactivated_account_message
            ? _c("AccountDeactivatedModal")
            : _vm._e(),
          _vm._v(" "),
          _c("ChurnTrackingBlock"),
          _vm._v(" "),
          _vm.showReferAFriendModal
            ? _c("ReferAFriendModal", {
                attrs: {
                  as: "referee",
                  "free-months-count": _vm.referralModalInfoData.free_months,
                  "referrer-name": _vm.referralModalInfoData.referrer_name
                },
                on: { close: _vm.closeReferAFriendModal }
              })
            : _vm._e()
        ],
        1
      )
    : _c("SavvyFlow", { attrs: { "flow-id": _vm.loggedOutHomepageFlowId } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }